import React from "react";
import { BrowserRouter, Route } from "react-router-dom";

import EventFilters from "./EventFilters";
import EventOverviewResults from "./EventOverviewResults";
import Pager from "./Pager";

import useFilters from "../hooks/useFilters";

const EventOverview = ({ history, filters, isArchive }) => {
    const [
        events,
        activeFilters,
        changeFilters,
        pagination,
        changePagination,
        loading,
    ] = useFilters(history, isArchive);

    return (
        <div className="event-overview">
            {filters && filters.length > 0 && (
                <EventFilters
                    filters={filters}
                    activeFilters={activeFilters}
                    changeFilters={changeFilters}
                />
            )}
            <EventOverviewResults
                events={events}
                loading={loading}
            />
            {pagination.total > 1 && (
                <div className="event-overview__pager">
                    <Pager
                        activePage={pagination.current}
                        pageCount={pagination.total}
                        changePage={changePagination}
                    />
                </div>
            )}
        </div>
    );
};

const EventOverviewWithRouter = ({ filters, isArchive }) => (
    <BrowserRouter>
        <Route
            path="/"
            component={(props) => (
                <EventOverview
                    filters={filters}
                    isArchive={isArchive}
                    {...props}
                />
            )}
        />
    </BrowserRouter>
);

export default EventOverviewWithRouter;
